<script setup lang="ts">

</script>

<template>
	<div class="faq-button-skeleton">
		<f7-skeleton-block class="skeleton-effect-wave" />
	</div>
</template>

<style scoped lang="scss">
.faq-button-skeleton {
	--skeleton-color: #DBDDE4;

	.skeleton-block {
		height: 48px;
		border-radius: 8px;
	}
}
</style>
